import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BaseCommonComponent, UserService, BaseDataService, ModalService, BaseModalUpdateComponent, ModalContainerService, BaseUpdateComponent, ModelData, TableRowColor, ConditionType, NotificationService, ConfirmationDialogButtons } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SpisakDokumenata } from './spisak-dokumenata';
import { VezaDok } from 'src/app/lookups/veza-dok/veza-dok';
import { OdabirDokumenata, OdabirDokumenataStavke } from './odabir-dokumenta';
import { SpisakDokumenataStavkeV2, SpisakDokumenataV2 } from './spisak-dokumenata-v2';
import { forkJoin, Notification, Observable, of, throwError } from 'rxjs';
import { map, delay, catchError } from 'rxjs/operators';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-odabir-avansa-v2',
  templateUrl: './odabir-avansa-v2.component.html'
})
export class OdabirAvansaV2Component implements OnInit {

  constructor(
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected userService: UserService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  )
  {
    
  }
  Config={};
  items = [];
  Items2: [];
  modelData: ModelData;
  @Input() Parameters;
  itemVezaDok: VezaDok = <VezaDok>{};
  rowColors: TableRowColor[];
  odabirDokumenta: OdabirDokumenata = <OdabirDokumenata>{};
  odabirDokumentaStavke: OdabirDokumenataStavke = <OdabirDokumenataStavke>{};
  @ViewChild("defaultTable", { static: true }) defaultTable;
  @Input() legends = [
    {name: 'LEGENDA.ISTIOBJEKAT', color: '#fed9ca'},
    {name: 'LEGENDA.POSTOJIVEZA', color: '#BEBEBE'}
  ];
  ts: string;
  ds: string;
  loading: boolean = false;
  numberOfItems: number = 0;

  ngOnInit() {
    this.ts = this.userService.GetThousandSeparator();
    this.ds = this.userService.GetDecimalSeparator();
    this.odabirDokumenta["FakDokumentID"]=this.Parameters[0].Value;
    this.odabirDokumenta["Url"]=this.Parameters[1].Value;
    this.loading = true;
    this.baseDataService.Post('OdabirDokumenata','GetDokumenteByFakDokumentID',this.odabirDokumenta,SpisakDokumenataV2)
      .subscribe(data => {
      this.numberOfItems = data == null ? 0 : data.length;
      if (data && data != null){
        data.forEach(d => {
          if (d.Checked){
            this.baseDataService.Post("OdabirDokumenata", "getSumePoTarifamaByAvansId", {'VezaDokID': d.VezaDokID, 'ID': d.ID}, SpisakDokumenataStavkeV2)
              .subscribe((data2 : SpisakDokumenataStavkeV2[])=>{
                  data2.forEach(item =>{
                    d.Details.push(item);
                  })
                
              })  
          }
        })
        this.items = data;
        this.Config={
          // EditIcon: {
          //   Visible: false
          // },
          // DeleteIcon: {
          //   Visible: false
          // },
          // DefaultSortKey: this.modelData.MainList.SortBy,
          // DefaultSortReverse: this.modelData.MainList.SortReverse,
          // ShowIndex: false,
          // ShowDefaultListButtons: false,
          ShowCheckBoxes: true
          // PrintIcon: {
          //   Visible: false
          // }
          , BreadCrumble: this.modelData.BreadcrumbLabel
          
        }
      }
      this.loading = false;
    });
  }


  ngAfterContentInit(){
    this.rowColors = [    
      { 
        ColumnName: 'ObjekatID',
        Condition: ConditionType.Equals,
        Value: this.Parameters==undefined ? 0 : this.Parameters[3].Value==null ? 0 : this.Parameters[3].Value,
        Color: '#fed9ca'
      },
      { 
        ColumnName: 'VezaDokID',
        Condition: ConditionType.GreaterThan,
        Value: 0,
        Color: '#BEBEBE'
      }
    ];
  }

  Save(){    
    if (!this.ControlItemDetails(this.items))
      return false;
    let fakdokumentID : number = this.Parameters[0].Value;
    // let checkedIDs : string = "";
    // let genericName : string = "";
    // let genericNameArray = [];
    if (this.items){
      let avansID: number;
      let avansStavkaID: number;
      let iznos: number;
      let uspesno: boolean = false;
      let tarifaID: number;

      const avansiList  = [];
      
      this.loading = true;
      for (const item of this.items){
          avansID = item.ID;
          if (item.Details && item.Details.length != 0)
          {
            for (const item2 of item.Details){
                avansStavkaID = item2.ID;
                tarifaID = item2.TarifaID;
                iznos = typeof(item2.Iznos) == "string" ? parseFloat(item2.Iznos.replace(new RegExp('\\' + this.ts, 'g'), '').replace(this.ds, '.')) : item2.Iznos;                
                // avansiList.push({'FakDokumentID' : fakdokumentID, 'AvansID' : avansID, 'TarifaID' : tarifaID, 'Iznos' : iznos, 'IsChecked' : item.Checked});
                avansiList.push({'AvansID' : avansID, 'TarifaID' : tarifaID, 'Iznos' : iznos, 'IsChecked' : item.Checked});

            }
        }
      }  
      
      // await  this.SaveinVezaDokAvansi(avansiList, uspesno)
   

      // await  this.SaveinVezaDokAvansi(fakdokumentID, avansiList, uspesno)    
      // .subscribe((result)=>{
      //   this.loading = false;
        
      //   if (result)
      //     {
      //       this.translateService.get(["ODABIRAVANSA.SAVE.TEXT"])
      //       .subscribe(translate => {
      //         // this.notificationService.success("Uspešno", "Sačuvane veze sa dokumentom.");
      //         this.toastrService.success("Uspešno", "Sačuvane veze sa dokumentom.");
      //         this.activeModal.close(true);
      //       });     
      //     }
      //     else      
      //       this.activeModal.close(true); 
      // })

      this.SaveinVezaDokAvansi(fakdokumentID, avansiList)
      .subscribe({
        next: (result) => {
          this.loading = false;

          if (result) {
            this.translateService.get(["ODABIRAVANSA.SAVE.TEXT"])
              .subscribe(translate => {
                this.toastrService.success("Uspešno", "Sačuvane veze sa dokumentom.");
                this.activeModal.close(true);
              });
          } else {
            this.activeModal.close(true);
          }
        },
        error: (err) => {
          this.loading = false;

          const msg = err?.error;

          // this.toastrService.error("Greška", msg);
          this.modalService.ShowConfirmationDialog("Problemi kod snimanja avansa", msg, "warning", ConfirmationDialogButtons.Ok);
        }
      });
      

    }
  }

  
  // SaveinVezaDokAvansi(spisak: any[], uspesno: boolean):Observable<boolean>{
  //   if(spisak){
  //       //samo sa forkJoin, radi jedan po jedan i onda pređe na kraju na uspesno = true 
  
  //         return forkJoin(spisak.map(item => 
  //           this.baseDataService.Post("FakDokument","SavePovezivanjeDokumenataAvansi",{'FakDokumentID' : item['FakDokumentID'], 'AvansID' : item['AvansID'], 'TarifaID' : item['TarifaID'], 'Iznos' : item['Iznos'], 'IsChecked' : item['IsChecked']} ,null)))
  //           .pipe(
  //             map(()=>
  //             uspesno = true
  //           ))      
    
  
  //       }
  //   else
  //     return of(uspesno);
  // }

  SaveinVezaDokAvansi(fakDokumentID: number, avansiList: any[]):Observable<boolean>{
    if (!avansiList || avansiList.length === 0) {
    return of(false);
    }

    return this.baseDataService
      .Post(
        "FakDokument",
        "SavePovezivanjeDokumenataAvansi",
        { FakDokumentID: fakDokumentID, Avansi: avansiList },
        null
      )
      .pipe(
        map(() => true),
        catchError(err => {
          return throwError(err);
        })
      );
  }

  Close(){
    this.activeModal.dismiss();
  }
  
  
  ControlItemDetails(items: any[]):Boolean{
    // let result = true;
    let imaIznos0 : Boolean = false;
    let iznosVeciOdOstalo : boolean = false;
    let ukupanIznosPoAvansu : Number = 0;
    items.forEach(element => {
      ukupanIznosPoAvansu = 0;
      if (element.Checked){
        element['Details'].forEach(element2 => {
          if(element2.Iznos > element2.Ostalo){
            iznosVeciOdOstalo = true;
            // this.translateService.get(["ODABIRAVANSA.CHECKITEM.TEXT"])
            //   .subscribe(translate => {
            //     this.notificationService.warn(translate["ODABIRAVANSA.CHECKITEM.TEXT"]);   
            //     result = false;
            //   });                
          }
          ukupanIznosPoAvansu += element2.Iznos;            

          });
        if (ukupanIznosPoAvansu == 0)
          imaIznos0 = true;
      }
    });
    if (imaIznos0){
      this.translateService.get(["ODABIRAVANSA.CHECKITEMMUSTVALUE.TEXT"])
        .subscribe(translate => {
          // this.notificationService.warn(translate["ODABIRAVANSA.CHECKITEMMUSTVALUE.TEXT"]);   
          this.toastrService.warning(translate["ODABIRAVANSA.CHECKITEMMUSTVALUE.TEXT"]); 
        });    
    }
    if (iznosVeciOdOstalo){
      this.translateService.get(["ODABIRAVANSA.CHECKITEM.TEXT"])
        .subscribe(translate => {
          // this.notificationService.warn(translate["ODABIRAVANSA.CHECKITEM.TEXT"]);  
          this.toastrService.warning(translate["ODABIRAVANSA.CHECKITEM.TEXT"]);  
        });                
    }

    if (imaIznos0)
      return false;
    else if (iznosVeciOdOstalo)
      return false;
    else
      return true;
  }
}
